import {
	JSResourceForInteraction,
	type PreloadableJSResourceReference,
} from '@atlassian/react-async';

/**
 * Main entry for the /jira/sync-wait route (holding page shown while workspace syncs).
 * Passed to createPageEntryPoint in the sync-wait route entry. Do not use createEntryPoint
 * in router-routes—use a plain { root, getPreloadProps } object instead (see go/route-entrypoints).
 */
export const syncWaitPageEntryPoint: {
	root: PreloadableJSResourceReference<() => React.JSX.Element>;
	getPreloadProps: () => {
		queries: {};
		extraProps: {};
	};
} = {
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-sync-wait-page-entrypoint" */ './SyncWaitPage.tsx'),
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
};
